import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Modal } from "antd";

import {
  ProfileAction,
  BlocklistAction,
  NewMembersAction,
  MyNotesAction,
  SubscriptionAction,
  ShortlistAction,
  InterestAction,
  PhotoreqAction,
  ProfileViewerAction,
  ContactViewerAction,
  NotificationAction,
  SidebarCountAction,
} from "../../../store/actions";

import useScreenSize from "../../../utils/usescreensize";

import Sidebar from "./sidebar/sidebar";
import NavHeader from "./navheader";
import BottomBarMenu from "../../bottombarmenu/bottombarmenu";
import PromotionHeader from "./promotionheader";

import PrimaryButton from "../../button/primarybutton";
import VioletButtonLarge from "../../button/violetbuttonlarge";

import "./styles.css";

import { BASE_URL_LANDING } from "../../../config/constants/index";

const DashboardLayout = ({ children }) => {
  const screenSize = useScreenSize();
  const dispatch = useDispatch();
  const location = useLocation();

  const pathname = location.pathname;

  const user = useSelector((state) => state.auth?.user);
  const profileData = useSelector((state) => state.profile?.profile);
  const promo = useSelector((state) => state.profile?.promo);

  const [showBottomBar, setShowBottomBar] = useState(true);
  const [promotionHeader, setPromotionHeader] = useState(false);
  const [isPromotionModalOpen, setIsPromotionModalOpen] = useState(false);
  const [promoData, setPromoData] = useState(false);

  useEffect(() => {
    if (profileData?.profileCompleteness < 40) {
      const url = `${BASE_URL_LANDING}/register/basic-info?token=${user}&username=${profileData?.userName}&gender=${profileData?.gender}`;
      window.location.href = url;
    }
  }, [profileData]);

  useEffect(() => {
    if (promo?.length > 0) {
      setPromoData(promo[0]);
      setIsPromotionModalOpen(true);
    }
  }, [promo, profileData]);

  useEffect(() => {
    dispatch(
      ProfileAction.getProfile((res) => {
        if (res?.activePlan) {
          dispatch(
            SubscriptionAction.getSubscriptionInfo({
              transactionId: res?.activePlan?.transactionId,
            })
          );
        }
      })
    );
  }, [user]);

  useEffect(() => {
    const payloadContactView = {
      filter: "My Contact Viewers",
    };
    const payloadGeneral = {
      from: 0,
    };
    dispatch(InterestAction.getInterestsAll());
    dispatch(PhotoreqAction.getPhotoreqAll());
    dispatch(ShortlistAction.getShortlistAll());
    dispatch(BlocklistAction.getBlocklist(payloadGeneral));
    dispatch(MyNotesAction.getNotes(payloadGeneral));
    dispatch(NewMembersAction.getNewMembers(payloadGeneral));
    dispatch(ProfileViewerAction.getAllProfileViewer(payloadGeneral));
    dispatch(ProfileViewerAction.getProfileViewer(payloadGeneral));
    dispatch(ContactViewerAction.getContactView(payloadContactView));
    dispatch(ContactViewerAction.getAllContactView(payloadContactView));
    dispatch(NotificationAction.getNotifications());
    dispatch(ProfileAction.getPromo());
    dispatch(SidebarCountAction.getSidebarCount());
  }, [profileData]);

  useEffect(() => {
    dispatch(SubscriptionAction?.getPaymentPlan());
  }, []);

  useEffect(() => {
    if (
      pathname.includes("/edit-profile") ||
      pathname.includes("/view-profile") ||
      pathname.includes("/match-preference") ||
      pathname.includes("/gallery") ||
      pathname.includes("/trust-badge")
    ) {
      setShowBottomBar(false);
    } else {
      setShowBottomBar(true);
    }
  }, [pathname]);

  return (
    <div className={promotionHeader ? "dashboard-layout-promotion" : ""}>
      {promotionHeader && <PromotionHeader />}
      <div
        className="dashboard-layout"
        style={{ height: promotionHeader ? "calc(100vh - 60px)" : "100vh" }}
      >
        <Sidebar promotionheader={promotionHeader} />

        <div className="dashboard-right-side">
          <NavHeader promotionheader={promotionHeader} />
          <div
            className="content"
            style={{
              height: promotionHeader
                ? "calc(100vh - 140px)"
                : "calc(100vh - 80px)",
            }}
          >
            <Outlet />
            {children}
          </div>
        </div>
        {screenSize.width < 1024 && showBottomBar && (
          <>
            <div style={{ height: "60px" }}></div>
            <BottomBarMenu />
          </>
        )}
      </div>
      <Modal
        centered={true}
        open={isPromotionModalOpen}
        onCancel={() => setIsPromotionModalOpen(false)}
        footer={null}
        closable={true}
        autoFocusButton
      >
        <div className="flex flex-col justify-center items-center gap-3">
          <img src={promoData?.image} className="h-[200px] w-max" alt="promo" />
          <div className="text-[22px] font-bold">{promoData?.title}</div>
          <div className="text-[18px] font-medium">
            {promoData?.description}
          </div>
          <div className="flex gap-2 w-[70%]">
            <PrimaryButton
              text={promoData?.cancelBtn}
              onClick={() => setIsPromotionModalOpen(false)}
            />
            <Link to={promoData?.route}>
              <VioletButtonLarge
                style={{ width: "160px" }}
                text={promoData?.acceptBtn}
              />
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DashboardLayout;
